// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { ChangeDetectorRef, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { Client } from '@microsoft/microsoft-graph-client';
import * as MicrosoftGraph from '@microsoft/microsoft-graph-types';
import { LoadingService } from 'src/app/loader/loading.service';
import { AuthserviceService } from 'src/app/service/authservice.service';
import { SubserviceService } from 'src/app/service/subservice.service';


import { OAuthSettings } from './ms-oauth';
import { User } from './user';
import { AuthService } from './_services/auth.service';

@Injectable({
  providedIn: 'root'
})

export class MsAuthService {
  public authenticated: boolean;
  public user?: User;
  hasError: boolean;

  // <ConstructorSnippet>
  constructor(
    private msalService: MsalService, private subService: SubserviceService,
    private gettersetter: AuthserviceService, private authService: AuthService,
    private router: Router, private loadingService: LoadingService) {

    this.authenticated = this.msalService.instance
      .getAllAccounts().length > 0;

    this.getUser(this.authenticated).then((user) => {
      this.user = user;
      console.log(this.user);
    });



  }
  // </ConstructorSnippet>

  // Prompt the user to sign in and
  // grant consent to the requested permission scopes
  async msSignIn(): Promise<void> {
    const result = await this.msalService
      .loginPopup(OAuthSettings)
      .toPromise()
      .catch((reason) => {

      });

    if (result) {
      this.authenticated = true;
      this.user = await this.getUser(this.authenticated);
      this.subService.mslogin(this.user.email).subscribe(response => {

        if (response != '') {

          const responseData = JSON.parse(response);
          // console.log("RRRRRRRRRRRRRRRRRRRRRRR",responseData  );

          if (responseData.status) {
            this.hasError = false;
            let rights = responseData.response.rights.split(", ");
            this.gettersetter.setRights(rights);

            // console.log("En",btoa(responseData.response.locationId));

            this.gettersetter.setCurrentlocationId(responseData.response.locationId);

            this.authService.setIsValidUser();

            //this.gettersetter.setBarierToken(responseData.response.Authorization);

            localStorage.setItem('token', responseData.response.Authorization);

            // this.gettersetter.setUserrole(responseData.response.role);
            localStorage.setItem('userrole', btoa(responseData.response.role));

            if (responseData.response.endUserRole) {
              this.gettersetter.setEndUserRole(btoa(responseData.response.endUserRole));
            }


            // console.log("sadsdadsasdasdasdasd",btoa(responseData.response.email));

            this.gettersetter.setEmail(btoa(responseData.response.email));

            this.gettersetter.setProfileImage(responseData.response.profileImg)

            // this.gettersetter.setUserId(responseData.response.id);
            //  console.log("13  ",btoa(responseData.response.id));
            localStorage.setItem('userId', btoa(responseData.response.id));


            if (responseData.response.role == 'CUSTOMER ADMIN') {
              this.gettersetter.setUsername(responseData.response.name);
              this.subService.findUser(responseData.response.id).subscribe(response => {
                const responseData = JSON.parse(response);
                // console.log(responseData);

                this.gettersetter.setProfileImage(responseData.customerDetails.user.profileImg)
              })
              this.router.navigate(['/mradmin/mradmin_settings']);
            }
            if (responseData.response.role == 'BACK OFFICE ADMIN') {
              this.subService.findUser(responseData.response.id).subscribe(response => {
                const responseData = JSON.parse(response);
                this.gettersetter.setProfileImage(responseData.user.profileImg)
              })
              this.gettersetter.setUsername(responseData.response.username);
              this.router.navigate(['workspace-dashboard']);
            }
            if (responseData.response.role == 'USER') {
              this.subService.findUser(responseData.response.id).subscribe(response => {
                const responseData = JSON.parse(response);
                this.gettersetter.setProfileImage(responseData.user.profileImg)
              })
              this.gettersetter.setUsername(responseData.response.name);
              this.router.navigate(['dashboard']);
            }
            this.loadingService.requestEnded();
          } else {
            this.hasError = true;
            // this.cdr.markForCheck();
            this.loadingService.requestEnded();
          }
        } else {
          this.hasError = true;
          // this.cdr.markForCheck();
          this.loadingService.requestEnded();
        }
      });

    }
  }

  // Sign out
  async msSignOut(): Promise<void> {
    await this.msalService.logout().toPromise();
    this.user = undefined;
    this.authenticated = false;
  }

  // Silently request an access token
  async getAccessToken(): Promise<string> {
    const account = this.msalService.instance.getAllAccounts()[0];
    const result = await this.msalService
      .acquireTokenSilent({
        account: account ?? undefined,
        scopes: OAuthSettings.scopes
      })
      .toPromise()
      .catch((reason) => {

      });

    if (result) {
      localStorage.setItem('microsoftToken', result.accessToken);
      return result.accessToken;
    }

    // Couldn't get a token
    this.authenticated = false;
    return '';
  }

  // <GetUserSnippet>
  async getUser(authenticated): Promise<User | undefined> {
    if (!authenticated) return undefined;

    const graphClient = Client.init({
      // Initialize the Graph client with an auth
      // provider that requests the token from the
      // auth service
      authProvider: async (done) => {
        const token = await this.getAccessToken()
          .catch((reason) => {
            done(reason, null);
          });

        if (token) {
          // console.log(token);
          done(null, token);
        } else {
          done("Could not get an access token", null);
        }
      }
    });

    // Get the user from Graph (GET /me)
    const graphUser: MicrosoftGraph.User = await graphClient
      .api('/me')
      .select('displayName,mail,userPrincipalName')
      .get();

    const user = new User();
    user.displayName = graphUser.displayName ?? '';
    // Prefer the mail property, but fall back to userPrincipalName
    user.email = graphUser.mail ?? graphUser.userPrincipalName ?? '';
    user.timeZone = graphUser.mailboxSettings?.timeZone ?? 'UTC';

    // Use default avatar
    user.avatar = '/assets/no-profile-photo.png';

    return user;
  }
  // </GetUserSnippet>
}